/*AOS.init({
    startEvent: 'DOMContentLoaded',
    once: true
});*/

jQuery(document).ready( function (event) {
    if ( jQuery( '.how-it-works-slider' ).length ) {
        let dots = false
        if ( jQuery( '.how-it-works-slider > div' ).length > 4 ) {
            dots = true;
        } else {
            dots = false;
        }
        jQuery( '.how-it-works-slider' ).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            // mobileFirst: true,
            arrows: false,
            dots: dots,
            // adaptiveHeight: true,
            infinite: false,
            // variableWidth: false,
            initialSlide: 0,
            accessibility: true,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '5%',
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '5%',
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '7%',
                        centerMode: true,
                        // centerPadding: '5%',
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
        if (jQuery(window).width() < 769) {
            jQuery( '.how-it-works-slider .slick-slide' ).removeClass('slick-hide');
            jQuery('.how-it-works-slider .slick-current').prev().addClass('slick-hide');
        }
    }
    if ( jQuery( '.program-image-slider-custom' ).length ) {
        jQuery( '.program-image-slider-custom' ).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            dots: true,
            // adaptiveHeight: true,
            infinite: true,
            // variableWidth: false,
            initialSlide: 0,
            accessibility: true,
            centerPadding: '10%',
            centerMode: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '7%',
                        centerMode: true,
                        // centerPadding: '5%',
                    }
                },
                {
                    breakpoint: 1024,
                    settings: "unslick",
                },
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
        if (jQuery(window).width() < 769) {
            jQuery( '.program-image-slider-custom .slick-slide' ).removeClass('slick-hide');
            jQuery('.program-image-slider-custom .slick-current').prev().addClass('slick-hide');
        }
    }
    if ( jQuery( '.pp-challenges-into-oportunities-slider' ).length ) {
        if ( jQuery( '.pp-challenges-into-oportunities-slider > div' ).length > 3 ) {
            dots = true;
        } else {
            dots = false;
        }
        jQuery( '.pp-challenges-into-oportunities-slider' ).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            // mobileFirst: true,
            arrows: false,
            dots: dots,
            // adaptiveHeight: true,
            infinite: true,
            // variableWidth: false,
            initialSlide: 0,
            accessibility: true,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: dots,
                        centerPadding: '5%',
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '5%',
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '7%',
                        centerMode: true,
                        // centerPadding: '5%',
                    }
                },
                {
                    breakpoint: 499,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '15%',
                        centerMode: true,
                        // centerPadding: '5%',
                    }
                },
                {
                    breakpoint: 399,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '6%',
                        centerMode: true,
                        // centerPadding: '5%',
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
        if (jQuery(window).width() < 769) {
            jQuery( '.pp-challenges-into-oportunities-slider .slick-slide' ).removeClass('slick-hide');
            jQuery('.pp-challenges-into-oportunities-slider .slick-current').prev().addClass('slick-hide');
        }
    }
})